import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/ui/dialog";
import { Button } from "components/ui/button";
import { ArrowTopRightOnSquareIcon, DocumentTextIcon } from "@heroicons/react/24/outline";

interface InvoiceListModalProps {
  isOpen: boolean;
  onClose: () => void;
  cnNumber: string;
  invoiceLinks: Record<string, string>;
}

export const InvoiceListModal: React.FC<InvoiceListModalProps> = ({
  isOpen,
  onClose,
  cnNumber,
  invoiceLinks,
}) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md p-7 rounded-xl shadow-md">
        <DialogHeader>
          <DialogTitle className="text-base font-semibold text-gray-800">
            Invoices — CN <span className="text-gray-600">{cnNumber}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 mt-3 max-h-[60vh] overflow-y-auto">
          {invoiceLinks && Object.keys(invoiceLinks).length > 0 ? (
            Object.entries(invoiceLinks).map(([invoiceNum, url], idx) => {
              return (
                <div key={idx} className="flex items-center justify-between gap-4 py-1 border-b border-gray-50 last:border-0">
                  <div className="flex items-center gap-3 min-w-0">
                    <div className="p-2 rounded-full bg-gray-100 shrink-0">
                      <DocumentTextIcon className="h-5 w-5 text-gray-600" />
                    </div>
                    <p className="text-sm font-medium text-gray-800 truncate" title={invoiceNum}>
                      {invoiceNum}
                    </p>
                  </div>
                  <Button
                    size="sm"
                    variant="outline"
                    className="h-7 px-2.5 text-[12px] border-gray-200 text-gray-700 hover:bg-gray-50 shrink-0"
                    onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
                  >
                    <ArrowTopRightOnSquareIcon className="h-4 w-4 mr-1" />
                    Invoice
                  </Button>
                </div>
              );
            })
          ) : (
            <div className="text-sm text-gray-500 py-10 text-center">
              No Invoices available.
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
